import { relativeRound } from '@zapier/common-utils';
import { PriceFormattingOptions } from '@zapier/design-system-revenue/src/types';

/**
 * Formats a price in pennies to be a price in dollars
 */
export default (
  price: number,
  {
    maxDecimals = 2,
    minDecimals = 0,
    useRelativeRounding = false,
  }: PriceFormattingOptions = {} as PriceFormattingOptions
): string => {
  // round if we need to
  const rounded = useRelativeRounding ? relativeRound(price) : price;

  // Price is given in pennies so convert to dollars
  const priceInDollars = rounded / 100;

  // Only show decimals if we have pennies or we are forcing them
  const hasPennies = priceInDollars % 1 !== 0;

  const options = {
    maximumFractionDigits: maxDecimals,
    minimumFractionDigits: minDecimals === 0 && hasPennies ? 2 : minDecimals,
  };

  // format the price in the user's locale
  return priceInDollars.toLocaleString(undefined, options);
};
